const MAX_EXTERNAL_LINK_LENGTH = 32_768;

/**
 * Parses a link that a Custom App asks the host to open: `https:` links to a named host, and `mailto:` and `tel:`
 * links. Returns null for other links, including https links with credentials, which could disguise the destination.
 */
export function parseCustomAppExternalLink(value: unknown): URL | null {
	if (typeof value !== "string" || value.length > MAX_EXTERNAL_LINK_LENGTH) return null;
	const url = parseUrl(value);
	if (url === null) return null;
	switch (url.protocol) {
		case "https:":
			return url.hostname !== "" && url.username === "" && url.password === "" ? url : null;
		case "mailto:":
		case "tel:":
			return url.pathname !== "" || url.search !== "" ? url : null;
		default:
			return null;
	}
}

// URL.canParse is missing from Safari before 17.
function parseUrl(value: string): URL | null {
	try {
		return new URL(value);
	} catch {
		return null;
	}
}

/**
 * Opens a parsed link in a new tab without access to Aavo. Call while the user action that requested it is active.
 * Mail and phone links get a new tab too, because a web mail handler would otherwise replace the Aavo page.
 */
export function openCustomAppExternalLink(url: URL) {
	window.open(url.href, "_blank", "noopener,noreferrer");
}
